import localforage from "localforage";

/** The podcasts a listener follows without an account, kept on this device */
export const DEVICE_FOLLOWS_KEY = "hp_device_follows";

/** The most a device keeps; the sign-in import takes at most this many too */
export const MAX_DEVICE_FOLLOWS = 500;

const isFollow = (value: unknown): value is FollowedPodcast => {
    if (!value || typeof value !== "object") return false;
    const v = value as Record<string, unknown>;
    return (
        typeof v.id === "number" &&
        Number.isInteger(v.id) &&
        v.id > 0 &&
        typeof v.name === "string" &&
        typeof v.slug === "string"
    );
};

export const readDeviceFollows = async (): Promise<FollowedPodcast[]> => {
    try {
        const value: unknown = await localforage.getItem(DEVICE_FOLLOWS_KEY);
        return Array.isArray(value) ? value.filter(isFollow).slice(0, MAX_DEVICE_FOLLOWS) : [];
    } catch {
        return [];
    }
};

export const writeDeviceFollows = async (podcasts: FollowedPodcast[]): Promise<void> => {
    try {
        await localforage.setItem(DEVICE_FOLLOWS_KEY, podcasts.slice(0, MAX_DEVICE_FOLLOWS));
    } catch {
        // Blocked or full: the follows then last only until the page is closed
    }
};

export const clearDeviceFollows = async (): Promise<void> => {
    try {
        await localforage.removeItem(DEVICE_FOLLOWS_KEY);
    } catch {
        // Nothing to clear when storage is blocked
    }
};
